import React from 'react';
import { Link } from 'react-router-dom';

type AuthLegalNoticeProps = {
  action: 'registering' | 'signing in';
  className?: string;
};

const AuthLegalNotice: React.FC<AuthLegalNoticeProps> = ({
  action,
  className = 'auth-legal-notice',
}) => (
  <p className={className}>
    By {action}, you agree to SkipScreen&apos;s{' '}
    <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </Link>
    ,{' '}
    <Link to="/cookie-policy" target="_blank" rel="noopener noreferrer">
      Cookie Policy
    </Link>
    .
  </p>
);

export default AuthLegalNotice;
